<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
    import * as api from "@/api/index";
    export default {
        name: 'App',
        data() {
            return {

            }
        },
		mounted() {
			// console.log('paystatus',this.$route.query.pay_status);
			var str=location.href;
			const fixedString = "pay_status=";
			if(str.includes(fixedString)){
				var index=str.indexOf("=");
				var char=str.substring(index+11, index + 1);
				localStorage.setItem('pay_status',char);
				
			}
			
			
			
			// if(this.$route.query.pay_status){
			//   localStorage.setItem('pay_status', this.$route.query.pay_status);
			// }else{
			//   localStorage.setItem('pay_status', 1);
			// }
		}
    }
</script>

<style lang="scss">
    @import './assets/scss/public.scss';
    @import url("//at.alicdn.com/t/font_2369520_pu161hukjgo.css");

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue